import React from "react";
import styled from "styled-components";
import { ArrowUpRight } from "lucide-react";

const PurchaseSection = styled.div`
  border-left: 2px solid ${({ theme }) => theme.primary};
  padding-left: 16px;
`;

const SectionTitle = styled.span`
  display: block;
  font-size: 11px;
  font-weight: bold;
  text-transform: uppercase;
  letter-spacing: 1px;
  color: #888;
  margin-bottom: 8px;
`;

const LinksContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px 16px;
`;

const PurchaseLink = styled.a.attrs(({ href }) => ({
  href,
  target: "_blank",
  rel: "noreferrer",
}))`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  color: ${({ theme }) => theme.primary};
  text-decoration: none;
  font-size: 15px;

  &:hover {
    text-decoration: underline;
    text-underline-offset: 3px;
  }
`;

const LinkIcon = styled(ArrowUpRight)`
  width: 14px;
  height: 14px;
  flex-shrink: 0;
  opacity: 0.7;
`;

const PurchaseLinks = ({ links }) => {
  if (!links || Object.keys(links).length === 0) {
    return null;
  }

  return (
    <PurchaseSection>
      <SectionTitle>Buy</SectionTitle>
      <LinksContainer>
        {Object.entries(links).map(([label, url]) => (
          <PurchaseLink key={label} href={url}>
            {label}
            <LinkIcon />
          </PurchaseLink>
        ))}
      </LinksContainer>
    </PurchaseSection>
  );
};

export default PurchaseLinks;
